import { useTheme } from "./ThemeContext";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={
        theme === "dark" ? "라이트 모드로 전환" : "다크 모드로 전환"
      }
      title={theme === "dark" ? "라이트 모드" : "다크 모드"}
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "1px solid var(--border-medium)",
        background: "var(--bg-card)",
        color: "var(--text-primary)",
        cursor: "pointer",
        fontSize: 18,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
        transition: "var(--transition-fast)",
      }}
    >
      {theme === "dark" ? "\u2600\uFE0F" : "\uD83C\uDF19"}
    </button>
  );
}
